(() => {
  const doc = document;
  const root = doc.documentElement;
  root.classList.remove('no-js');
  root.classList.add('js-enabled');
  const body = doc.body;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches || body.classList.contains('lr-no-motion');
  const cartPath = body.dataset.cartPath || '/cart';
  const addPath = body.dataset.addPath || '/cart/add';
  const changePath = body.dataset.changePath || '/cart/change';
  const currency = /^[A-Z]{3}$/.test(body.dataset.currency || '') ? body.dataset.currency : 'EGP';
  const formatMoney = cents => new Intl.NumberFormat('ar-EG', { style: 'currency', currency, maximumFractionDigits: 2 }).format((Number(cents) || 0) / 100);
  const track = doc.querySelector('[data-sticky-header]');
  const syncHeader = () => track?.classList.toggle('is-scrolled', window.scrollY > 16);
  window.addEventListener('scroll', syncHeader, { passive: true });
  syncHeader();

  const menuButton = doc.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = doc.getElementById('lr-mobile-menu');
  // menu open/close handled in lr-luxe.js

  if (!reduceMotion && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, handle) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          handle.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px 25px 0px', threshold: .05 });
    doc.querySelectorAll('.lr-reveal').forEach(element => observer.observe(element));
  } else {
    doc.querySelectorAll('.lr-reveal').forEach(element => element.classList.add('is-visible'));
  }

  if (!reduceMotion && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    doc.querySelectorAll('[data-tilt]').forEach(element => {
      let frame = 0;
      element.addEventListener('pointermove', event => {
        if (frame) return;
        frame = window.requestAnimationFrame(() => {
          const box = element.getBoundingClientRect();
          const x = (event.clientX - box.left) / box.width - .5;
          const y = (event.clientY - box.top) / box.height - .5;
          const strength = element.classList.contains('lr-product-card') ? 2.2 : 5;
          element.style.transform = `perspective(1000px) rotateX(${-y * strength}deg) rotateY(${x * strength}deg)`;
          frame = 0;
        });
      }, { passive: true });
      element.addEventListener('pointerleave', () => {
        window.cancelAnimationFrame(frame);
        frame = 0;
        element.style.transform = '';
      });
    });
  }

  // music is handled by lr-luxe.js

  const overlay = doc.querySelector('[data-cart-overlay]');
  const drawer = doc.querySelector('[data-cart-drawer]');
  const container = doc.querySelector('[data-cart-items]');
  const totalNode = doc.querySelector('[data-cart-total]');
  const cartButtons = doc.querySelectorAll('[data-open-cart]');
  let lastFocused = null;
  let loadingCart = false;
  const updateCounts = count => doc.querySelectorAll('[data-cart-count]').forEach(node => node.textContent = String(count));
  const closeCart = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.hidden = true;
    body.style.overflow = '';
    lastFocused?.focus?.();
  };
  const openCart = async () => {
    if (!drawer) { window.location.href = cartPath; return; }
    lastFocused = doc.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.hidden = false;
    body.style.overflow = 'hidden';
    drawer.focus();
    await refreshCart();
  };
  cartButtons.forEach(button => button.addEventListener('click', openCart));
  doc.querySelectorAll('[data-close-cart]').forEach(button => button.addEventListener('click', closeCart));
  overlay?.addEventListener('click', closeCart);
  doc.addEventListener('keydown', event => {
    if (event.key === 'Escape' && drawer?.classList.contains('is-open')) closeCart();
    if (event.key === 'Escape' && mobileMenu && !mobileMenu.hidden) {
      mobileMenu.hidden = true;
      menuButton?.setAttribute('aria-expanded', 'false');
      menuButton?.focus();
    }
    if (event.key === 'Tab' && drawer?.classList.contains('is-open')) {
      const allowed = [...drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')].filter(el => el.getClientRects().length);
      if (!allowed.length) return;
      const first = allowed[0], last = allowed[allowed.length - 1];
      if (event.shiftKey && doc.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && doc.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  const text = (tag, value, cls) => {
    const element = doc.createElement(tag);
    if (cls) element.className = cls;
    element.textContent = value;
    return element;
  };
  const removeItem = async key => {
    try {
      await fetch(`${changePath}.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) });
      await refreshCart();
    } catch { window.location.href = cartPath; }
  };
  const refreshCart = async () => {
    if (loadingCart) return;
    loadingCart = true;
    try {
      const response = await fetch(`${cartPath}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      updateCounts(cart.item_count);
      if (totalNode) totalNode.textContent = formatMoney(cart.total_price);
      if (!container) return;
      container.replaceChildren();
      if (!cart.items.length) {
        const empty = text('div', '', 'lr-drawer-empty');
        empty.appendChild(text('span', '♡'));
        empty.appendChild(text('p', 'لسه السلة فاضية… اختاري حاجة تدلّعك!'));
        container.appendChild(empty);
      }
      cart.items.forEach(item => {
        const row = doc.createElement('div'); row.className = 'lr-drawer-item';
        const picture = doc.createElement('a'); picture.href = item.url || cartPath;
        if (item.image) {
          const img = doc.createElement('img'); img.src = item.image; img.loading = 'lazy'; img.alt = item.product_title || '';
          picture.appendChild(img);
        }
        row.appendChild(picture);
        const content = doc.createElement('div');
        const name = text('strong', item.product_title || item.title || 'منتج');
        content.appendChild(name);
        if (item.variant_title && item.variant_title !== 'Default Title') content.appendChild(text('small', item.variant_title));
        content.appendChild(text('small', `الكمية: ${item.quantity}`));
        content.appendChild(text('b', formatMoney(item.final_line_price)));
        row.appendChild(content);
        const remove = text('button', '×', 'lr-drawer-item__remove');
        remove.type = 'button'; remove.setAttribute('aria-label', `حذف ${item.product_title || ''}`);
        remove.addEventListener('click', () => removeItem(item.key));
        row.appendChild(remove);
        container.appendChild(row);
      });
    } catch {
      if (container) container.replaceChildren(text('p', 'افتحي السلة لعرض طلبك.'));
    } finally { loadingCart = false; }
  };
  doc.querySelectorAll('form[data-ajax-add]').forEach(form => {
    form.addEventListener('submit', async event => {
      if (!drawer) return;
      event.preventDefault();
      const button = form.querySelector('button[type=submit]');
      if (button?.disabled) return;
      if (button) button.disabled = true;
      try {
        const response = await fetch(`${addPath}.js`, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Add to cart failed');
        await openCart();
      } catch { window.alert('ما قدرناش نضيف المنتج دلوقتي. جرّبي مرة تانية.'); }
      finally { if (button) button.disabled = false; }
    });
  });

  doc.querySelectorAll('[data-gallery-thumb]').forEach(button => button.addEventListener('click', () => {
    const gallery = button.closest('.lr-product-gallery');
    if (!gallery) return;
    const id = button.dataset.galleryThumb;
    gallery.querySelectorAll('[data-gallery-slide]').forEach(slide => {
      const showing = slide.dataset.gallerySlide === id;
      slide.hidden = !showing;
      if (!showing) slide.querySelectorAll('video').forEach(video => video.pause());
    });
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
      const active = thumb.dataset.galleryThumb === id;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', String(active));
    });
  }));
  doc.querySelectorAll('[data-variant-picker]').forEach(select => select.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    const price = doc.querySelector('[data-selected-price]');
    const compared = doc.querySelector('[data-compare-price]');
    if (price) price.textContent = option.dataset.price;
    if (compared) { compared.textContent = option.dataset.compare || ''; compared.hidden = !option.dataset.compare; }
    const submit = select.closest('form')?.querySelector('[data-product-submit]');
    if (submit) submit.disabled = option.dataset.available === 'false';
  }));
  doc.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
    const input = button.closest('.lr-stepper')?.querySelector('input[type=number]');
    if (!input) return;
    const next = (parseInt(input.value, 10) || 1) + (button.dataset.step === 'plus' ? 1 : -1);
    input.value = String(Math.max(1, next));
  }));
  doc.querySelectorAll('[data-auto-submit]').forEach(select => select.addEventListener('change', () => select.form?.requestSubmit()));
})();
